import {
  PAY_TYPE,
  PROPERTY_RANGE,
  RANGE,
  RIGHTS_FEATURE,
  SPEED,
  WATERMARK,
  type IAddPrice,
} from '~/api/interface';
import { MAX_RESOLUTION } from '~/api/interface/rights';

export const WATERMARK_MAP = () => {
  const { $t } = useNuxtApp();
  return new Map([
    [WATERMARK.no_watermark_with_custom, $t('wu-shui-yin-ke-zi-ding-yi-shui-yin')],
    [WATERMARK.has_watermark, $t('shui-yin-logo')],
    [WATERMARK.no_watermark, $t('wu-shui-yin')],
  ]);
};
export const MAX_RESOLUTION_MAP = new Map([
  [MAX_RESOLUTION.K_1, '1080'],
  // [MAX_RESOLUTION.UPGRADE_1080, '1080（可加购）'],
  [MAX_RESOLUTION.K_2, '2K'],
  [MAX_RESOLUTION.K_4, '4K'],
]);

export const RANGE_MAP = () => {
  const { $t } = useNuxtApp();
  return new Map([
    [RANGE.no, '-'],
    [RANGE.online, $t('xian-shang-yong-tu')],
    [RANGE.offline, $t('xian-xia')],
    [RANGE.all, $t('xian-shang-xian-xia-quan-yong-tu')],
  ]);
};

export const PROPERTY_RANGE_MAP = () => {
  const { $t } = useNuxtApp();
  return new Map([
    [PROPERTY_RANGE.ALL, $t('quan-bu')],
    [PROPERTY_RANGE.PART, $t('bu-fen')],
    [PROPERTY_RANGE.MORE, $t('geng-duo')],
  ]);
};

export const SPEED_MAP = () => {
  const { $t } = useNuxtApp();
  return new Map([
    [SPEED.one_speed, $t('zheng-chang')],
    [SPEED.two_speed, $t('pu-tong-jia-su-ke-fu-fei-pai-dui-jia-su')],
    [SPEED.three_speed, $t('gao-ji-jia-su')],
    [SPEED.four_speed, $t('chao-ji-jia-su')],
  ]);
};

export const PAY_TYPE_MAP = () => {
  const { $t } = useNuxtApp();
  return new Map([
    [PAY_TYPE.ALIPAY, $t('zhi-fu-bao')],
    [PAY_TYPE.WEIXIN, $t('wei-xin')],
    [PAY_TYPE.TRANSFER, $t('dui-gong-zhuan-zhang')],
  ]);
};

// 套餐时长常量
export const RIGHTS_TIME = () => {
  const { $t } = useNuxtApp();
  return {
    month: $t('dan-yue'),
    year: $t('yi-nian'),
  };
};

// 编辑器过来类型
export enum EDITOR_PAY_TYPE {
  COIN = 'coin',
  RIGHTS = 'rights',
  STORAGE = 'storage',
}

export const RightsFeature: () => {
  [key in RIGHTS_FEATURE]: {
    name: string;
    desc: string[];
    priceKey: keyof IAddPrice;
  };
} = () => {
  const { $t } = useNuxtApp();
  return {
    [RIGHTS_FEATURE.credit_coin]: {
      name: $t('yan-bi'),
      desc: [
        $t(
          'jia-gou-de-yan-bi-gou-mai-cheng-gong-hou-li-ji-sheng-xiao-yi-jing-sheng-xiao-bu-ke-tui-kuan',
        ),
        $t('tao-can-you-xiao-qi-nei-ke-yong-chang-qi-bao-liu'),
      ],
      priceKey: 'add_credit_coin',
    },
    [RIGHTS_FEATURE.sub_account_num]: {
      name: $t('zi-zhang-hao'),
      desc: [$t('jia-gou-hou-ke-zhi-chi-geng-duo-cheng-yuan-xie-zuo')],
      priceKey: 'add_account', // todo: 暂不需要
    },
    [RIGHTS_FEATURE.rendering_channel_num]: {
      name: $t('fu-wu-qi-zhuan-xian'),
      desc: [
        $t(
          'dang-qian-shi-yong-gong-gong-tong-dao-jia-gou-hou-ke-xian-zhu-jiang-di-yi-jian-sheng-cheng-cheng-pian-he-cheng-shi-jian',
        ),
      ],
      priceKey: 'add_render_pass', // todo: 暂不需要
    },
    [RIGHTS_FEATURE.storage]: {
      name: $t('cun-chu-kong-jian'),
      desc: ['xxx'],
      priceKey: 'add_storage', // todo: 暂不需要而且 key 错误
    },
  };
};

export enum TagKey {
  SCENARIO = 'template_application_scene',
  INDUSTRY = 'industry',
  LANGUAGE = 'language',
}
